export const INVIEW_TOGGLE_CSS = `
  [data-string-devtools-overlay-badge][data-module-enabled="false"] {
    display: none;
  }

  [data-string-devtools-overlay-badge][data-visible="false"] {
    display: none;
  }
`;
